var _g, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_591_10823)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 14.5,
    r: 14.5,
    fill: "black",
    fillOpacity: 0.09
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 14.5,
    r: 14,
    stroke: "white",
    strokeOpacity: 0.17
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.6125 18.8813L8.6 18.8938C8.43125 18.525 8.325 18.1063 8.28125 17.6438C8.325 18.1 8.44375 18.5125 8.6125 18.8813Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6252 13.4875C13.4467 13.4875 14.1127 12.8215 14.1127 12C14.1127 11.1784 13.4467 10.5125 12.6252 10.5125C11.8037 10.5125 11.1377 11.1784 11.1377 12C11.1377 12.8215 11.8037 13.4875 12.6252 13.4875Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1188 8.25H11.8812C9.60625 8.25 8.25 9.60625 8.25 11.8812V17.1188C8.25 17.8 8.36875 18.3938 8.6 18.8938C9.1375 20.0813 10.2875 20.75 11.8812 20.75H17.1188C19.3938 20.75 20.75 19.3938 20.75 17.1188V15.6875V11.8812C20.75 9.60625 19.3938 8.25 17.1188 8.25ZM19.7313 14.8125C19.2438 14.3938 18.4562 14.3938 17.9688 14.8125L15.3688 17.0437C14.8813 17.4625 14.0938 17.4625 13.6062 17.0437L13.3937 16.8687C12.95 16.4812 12.2438 16.4437 11.7438 16.7812L9.40625 18.35C9.26875 18 9.1875 17.5938 9.1875 17.1188V11.8812C9.1875 10.1187 10.1187 9.1875 11.8812 9.1875H17.1188C18.8813 9.1875 19.8125 10.1187 19.8125 11.8812V14.8812L19.7313 14.8125Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_591_10823",
    x: -104,
    y: -104,
    width: 237,
    height: 237,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 52
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_591_10823"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_591_10823",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileInfoIcon);
export default __webpack_public_path__ + "static/media/file-info-icon.5ecd9d63bec34808adff17d6b0784109.svg";
export { ForwardRef as ReactComponent };